import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
import Confirm from "../views/Confirm";
import NssfSignupForm from "../views/NssfSignupForm";
import PendingConfirmation from "../views/PendingConfirmation";
import SignupComplete from "../views/SignupComplete";
import SignupForm from "../views/SignupForm";
import SubscriptionForm from "../views/SubscriptionForm";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    beforeEnter: (to, from, next) => {
      next("/subscribe");
    },
  },
  {
    path: "/subscribe",
    name: "subscription",
    component: SubscriptionForm,
  },
  {
    path: "/pending-confirmation",
    name: "pendingConfirmation",
    component: PendingConfirmation,
  },
  {
    path: "/confirm",
    name: "confirm",
    component: Confirm,
  },
  {
    path: "/signup",
    name: "signup",
    component: SignupForm,
  },
  {
    path: "/signup-complete",
    name: "signupComplete",
    component: SignupComplete,
  },
  {
    path: "/nssf",
    name: "nssfSignup",
    component: NssfSignupForm,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
